// extracted by mini-css-extract-plugin
export default {"root":"SkeletonList_root__p1YPR","rows":"SkeletonList_rows__OK8OQ"};